'use strict';

module.exports = function () {
    document.addEventListener('vviinnTextSearchStarted', ({ detail }) => {
        if (detail.query) {
            const url = new URL(window.location);

            url.searchParams.set('q', detail.query);
            window.history.replaceState({}, '', url);
        }
    });
};
